// extracted by mini-css-extract-plugin
export var counterRow = "counter-row__YNNL";
export var recLink = "rec-link__UQeA";
export var recommendations = "recommendations__DuRg";
export var recommendations__empty = "recommendations__empty___T7Z";
export var recsContainer = "recs-container__CS3O";
export var text = "text__frLR";
export var tooltip = "tooltip__Gn2W";